import React from "react";
import { Statistic } from "antd";
import { statusList } from "../../../utils";

const statusOptions = statusList ? Object.keys(statusList) : [];

export const OrdersByStatus = ({ orders }) => {
  const statusCounts = {};
  orders?.forEach((order) => {
    const status = order.status;
    if (statusCounts[status]) {
      statusCounts[status] += 1;
    } else {
      statusCounts[status] = 1;
    }
  });

  return (
    <div className="w-fit p-6">
      <div className="flex flex-wrap justify-between mx-auto gap-1">
      {statusOptions.map((status) => (
        <div className="flex justify-center items-center text-center w-30" key={status}>
          <Statistic
            title={status}
            value={statusCounts[status] || 0}
          />
        </div>
      ))}
    </div>
    </div>
  );
};
